import { ICriteria } from './criteria.interface';

export interface ISaveReportRequest {
  criteria: ICriteria[];
  direction: string;
  fields: string[];
  id: number;
  name: string;
  orderCriteria: string;
  organization: string;
  pageNumber: number;
  pageSize: number;
  query: string;
  source: string;
  useEntityService: number;
}
